const Error = () => {
  return (
    <div id="body">
      <h1 className="Error">Error 404. Page Not Found</h1>
    </div>
  );
};

export default Error;
